import {
  ref,
  watch,
  inject,
  computed,
} from '@vue/composition-api';

export default (root, refs) => {
  const constants = inject('constants');
  // Right-side panel
  const drawerDetails = ref('optionalExtras'); // key for right sided panel with help text

  // Component displaying in the right-side panel
  const drawerComponent = ref(constants.DRAWER_COMPONENTS.resultsDetails);
  const isOptionsDrawerVisible = ref(false); // filter/re-quote panel goes to right side on mobile devices / visibility switcher for this panel
  const isDetailsDrawerOpen = ref(false);

  const drawerWidth = computed(() => {
    // coverBoost drawer is large, should stay this way on all devices
    if (drawerComponent.value === constants.DRAWER_COMPONENTS.coverBoostOptions) return 900;
    // On tablets and mobiles all drawers except coverBoost are 360px wide
    if (root.$vuetify.breakpoint.mdAndDown) return 360;
    // ResultsDetails is wider than other drawers on desktop because of two columns layout
    if (drawerComponent.value === constants.DRAWER_COMPONENTS.resultsDetails) return 720;
    // Default size
    return 600;
  });

  watch(isDetailsDrawerOpen, () => {
    const drawerElement = refs.drawer.$el;
    drawerElement.scrollIntoView();
  });
  const openDetailsDrawer = ([component, details]) => {
    if (details) {
      drawerDetails.value = details;
    }
    drawerComponent.value = component;
    isDetailsDrawerOpen.value = true;
  };

  const closeDetailsDrawer = () => {
    isDetailsDrawerOpen.value = false;
  };

  return {
    isOptionsDrawerVisible,
    isDetailsDrawerOpen,
    drawerDetails,
    drawerComponent,
    openDetailsDrawer,
    closeDetailsDrawer,
    drawerWidth,
  };
};
